import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "La nostra storia",
    text: "Star Edil SRLS nasce dalla nostra passione per l'edilizia e da oltre 20 anni di esperienza nel settore. Un percorso costruito sul campo, fatto di competenza, impegno e attenzione per ogni dettaglio.\n\nDa sempre affrontiamo ogni ristrutturazione con un obiettivo preciso: realizzare lavori di qualità, mantenendo cantieri ordinati, puliti e organizzati. Perché per noi professionalità significa non solo ottenere un ottimo risultato finale, ma anche lavorare con precisione e rispetto per gli spazi dei nostri clienti.",
  },
  {
    num: "02",
    title: "Il metodo chiavi in mano",
    text: "Un unico referente dal sopralluogo alla consegna. Preventivo dettagliato e trasparente, cronoprogramma rispettato, coordinamento di muratori, idraulici, elettricisti e finituri. Tu pensi solo a come arredare.",
  },
  {
    num: "03",
    title: "La squadra",
    text: "Artigiani interni e partner selezionati, tutti coperti da assicurazione e formati sulle normative più recenti. Sopralluogo e preventivo sono sempre gratuiti e senza impegno.",
  },
];

const stats = [
  { value: "30+", label: "Anni di esperienza" },
  { value: "800+", label: "Cantieri completati" },
  { value: "24h", label: "Risposta al preventivo" },
  { value: "100%", label: "Chiavi in mano" },
];

export const About = () => (
  <section id="chi-siamo" className="py-28 lg:py-40" data-testid="about-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="mb-20 lg:mb-28"
      >
        <p className="font-oswald text-gold uppercase tracking-[0.35em] text-sm mb-6">Chi siamo</p>
        <h2 className="font-display italic text-3xl md:text-5xl leading-tight max-w-3xl" data-testid="about-title">
          Costruiamo il futuro, <span className="text-gold">dalle fondamenta.</span>
        </h2>
      </motion.div>

      <div className="grid lg:grid-cols-3 gap-14 lg:gap-20 mb-24 lg:mb-32">
        {chapters.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.76, 0, 0.24, 1] }}
            className="border-t border-white/10 pt-8"
            data-testid={`about-chapter-${c.num}`}
          >
            <h3 className="font-oswald uppercase text-xl tracking-[0.12em] text-gold mb-5">{c.title}</h3>
            <p className="text-muted-foreground leading-loose text-base whitespace-pre-line">{c.text}</p>
          </motion.div>
        ))}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 border border-white/10" data-testid="about-stats">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className={`py-12 lg:py-16 px-6 text-center ${i < stats.length - 1 ? "lg:border-r border-white/10" : ""} ${i < 2 ? "max-lg:border-b max-lg:border-white/10" : ""} ${i === 0 ? "max-lg:border-r" : ""}`}
            data-testid={`stat-${i}`}
          >
            <span className="font-display text-5xl lg:text-6xl text-gold block">{s.value}</span>
            <span className="font-oswald uppercase text-xs tracking-[0.25em] text-muted-foreground mt-4 block">{s.label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
